import styled from "styled-components";

export const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 16px;
`;

export const GalleryItem = styled.div`
  cursor: pointer;
  border: 1px solid var(--gray-light);
  border-radius: 10px;
  overflow: hidden;
  background: var(--lightest);
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  img {
    width: 100%;
    height: 140px;
    object-fit: cover;
    display: block;
  }
`;

export const GalleryCaption = styled.div`
  padding: 8px 10px;
  font-size: 0.8rem;
  color: var(--neutral);
  line-height: 1.3;
`;
